<script>
import appConfig from '@/app.config'
import { Helper, debounce } from '@/mixin/helper'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import DetailTimeLog from './DetailTimeLog'
import moment from 'moment'
import { getSmsClient } from '@/services/sms'

const vsmsSmsAxios = getSmsClient()

moment.locale('id')

export default {
  page: {
    title: 'Work Time',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DetailTimeLog,
  },
  mixins: [Helper],
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      startDate: null,
      endDate: null,
      sortBy: 'wo_number',
      sortDesc: false,
      show_model: null,
      status: '',
      filter: null,
      filteredItems: [],
      startPlanDate: new Date().toISOString().slice(0, 10),
      endPlanDate: new Date().toISOString().slice(0, 10),
      tempStartPlanDate: new Date().toISOString().slice(0, 10),
      tempEndPlanDate: new Date().toISOString().slice(0, 10),
      loading: false,
      isLoading: false,
      workTimeList: [],
      modal: false,
      isEdit: false,
      detail: null,
    }
  },
  created() {
    this.getWorkTimeList()
  },
  computed: {
    title() {
      return this.$t('workOrder.column.workTime')
    },
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)
        return this.workTime.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.workTime
      }
    },
    workTime() {
      return [
        {
          key: 'technician',
          label: this.$t('workTime.column.technician'),
          sortable: true,
        },
        {
          key: 'wo_number',
          label: this.$t('workTime.column.woNumber'),
          sortable: true,
        },
        {
          key: 'plan_date',
          label: this.$t('workTime.column.planDate'),
          sortable: true,
        },
        {
          key: 'wo_started_at',
          label: this.$t('workTime.column.start'),
          sortable: true,
        },
        {
          key: 'wo_verified_at',
          label: this.$t('workTime.column.verify'),
          sortable: true,
        },
        {
          key: 'wo_ended_at',
          label: this.$t('workTime.column.end'),
          sortable: true,
        },
        {
          key: 'working_time',
          label: this.$t('workTime.column.workInHour'),
          sortable: true,
        },
        {
          key: 'lead_time',
          label: this.$t('workTime.column.leadInHour'),
          sortable: true,
        },
        {
          key: 'actual_working_time',
          label: this.$t('workTime.column.realInHour'),
          sortable: true,
        },
      ]
    },
  },
  methods: {
    async getWorkTimeList() {
      this.loading = true

      const qp = {
        page: this.currentPage,
        size: this.perPage,
      }
      if (this.startPlanDate) {
        qp.filters = qp.filters
          ? qp.filters + `;plannedOn:gte:${this.startPlanDate}`
          : `plannedOn:gte:${this.startPlanDate}`
      }
      if (this.endPlanDate) {
        qp.filters = qp.filters
          ? qp.filters + `;plannedOn:lte:${this.endPlanDate}`
          : `plannedOn:lte:${this.endPlanDate}`
      }
      const workTimeList = await vsmsSmsAxios
        .get('/work-order/work-time', {
          params: qp,
        })
        .catch((error) => {
          this.handleError(error)
        })

      if (!workTimeList?.data?.data) return

      this.filteredItems = workTimeList.data.data
      this.totalRows = workTimeList.data.total_count
      this.currentPage = workTimeList.data.page
      this.perPage = workTimeList.data.size
      this.totalPages = workTimeList.data.total_pages
      this.workTimeList = workTimeList.data.data

      this.loading = false
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 400) {
          if (error.response.data.details) {
            error.response.data.details.forEach((element) => {
              this.$toast.error(`${error.response.data.error}: ${element.field} ${element.message}`)
            })
          }
        } else {
          this.$toast.error(error.response.data.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    async exportWorkTime() {
      this.isLoading = true
      const qp = {}
      if (this.startPlanDate) {
        qp.filters = qp.filters
          ? qp.filters + `;plannedOn:gte:${this.startPlanDate}`
          : `plannedOn:gte:${this.startPlanDate}`
      }
      if (this.endPlanDate) {
        qp.filters = qp.filters
          ? qp.filters + `;plannedOn:lte:${this.endPlanDate}`
          : `plannedOn:lte:${this.endPlanDate}`
      }
      const respWorkTimeExport = await vsmsSmsAxios
        .get('/work-order/work-time/export', {
          params: qp,
          responseType: 'blob',
        })
        .catch((error) => {
          this.isLoading = false
          this.handleError(error)
        })

      if (!respWorkTimeExport?.data) return

      const url = window.URL.createObjectURL(respWorkTimeExport.data)
      const a = document.createElement('a')
      a.href = url
      a.download = 'WorkTime.xlsx'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      this.isLoading = false
    },

    changePage(e) {
      this.currentPage = e
      this.getWorkTimeList()
    },

    disabledRangeStart: function (date) {
      return (date >= new Date()) || (this.tempEndPlanDate ? (date > new Date(this.tempEndPlanDate)) : false)
    },

    disabledRangeEnd: function (date) {
      let endDateLimit = new Date(this.tempStartPlanDate)
      endDateLimit.setDate(endDateLimit.getDate() - 1);
      
      return (date >= new Date()) || (date < endDateLimit )
    },

    resetFilter(e) {
      this.currentPage = 1
      this.size = e
      this.getWorkTimeList()
    },

    searchData: debounce(function () {
      this.getWorkTimeList()
    }, 600),

    submitFilter() {
      this.startPlanDate = this.tempStartPlanDate
      this.endPlanDate = this.tempEndPlanDate
      this.getWorkTimeList()
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="clearfix mc-btn-group__list">
      <b-button @click="$router.back()" variant="outline-primary" class="ms-3">
        <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
      </b-button>
    </div>
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <b-row>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <b-form-group
                    id="start_plan_date"
                    :label="$t('workTime.form.startPlanDate')"
                    label-for="start_plan_date"
                  >
                    <date-picker
                      v-model="tempStartPlanDate"
                      format="DD MMM YYYY"
                      value-type="YYYY-MM-DD"
                      :placeholder="$t('workTime.form.startPlanDate')"
                      :first-day-of-week="1"
                      :disabled-date="disabledRangeStart"
                      lang="en"
                      confirm
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <b-form-group
                    id="end_plan_date"
                    :label="$t('workTime.form.endPlanDate')"
                    label-for="end_plan_date"
                  >
                    <date-picker
                      v-model="tempEndPlanDate"
                      format="DD MMM YYYY"
                      value-type="YYYY-MM-DD"
                      :placeholder="$t('workTime.form.endPlanDate')"
                      :first-day-of-week="1"
                      :disabled-date="disabledRangeEnd"
                      lang="en"
                      confirm
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col sm="12" md="3" class="d-flex align-items-end">
                <div class="mb-3">
                  <b-form-group id="submit_plan_date">
                    <b-button variant="primary" type="button" @click="submitFilter">
                      {{ this.$t('global.submit') }}
                    </b-button>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('workOrder.column.workTime') }}</span>
            </template>
            <template>
              <div>
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="clearfix">
                          <!-- Search -->
                          <div class="float-end">
                            <div class="mc-table-view">
                              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                <b-button
                                  variant="primary"
                                  type="button"
                                  @click="exportWorkTime"
                                  :disabled="!(workTimeList.length > 0) || isLoading"
                                >
                                  <b-spinner v-if="isLoading" small type="grow"></b-spinner>
                                  {{ this.$t('global.export') }}
                                </b-button>
                              </div>
                            </div>
                          </div>
                          <!-- End search -->
                        </div>

                        <!-- Table Tracking -->
                        <div class="table-responsive my-3 border border-1">
                          <b-table
                            small
                            show-empty
                            :items="workTimeList"
                            :fields="visibleFields"
                            class="datatables"
                            empty-table
                            :empty-text="$t('global.emptyTable')"
                            :empty-filtered-text="$t('global.emptyFilteredTable')"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :busy="loading"
                          >
                            <template #table-busy>
                              <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                              </div>
                            </template>
                            <template #thead-top>
                              <b-tr>
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th colspan="3" class="text-center">{{
                                  $t('workTime.column.logTime')
                                }}</b-th>
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th></b-th>
                              </b-tr>
                            </template>
                            <template #cell(plan_date)="data">
                              {{ data.item.plan_date ? momentDMHms(data.value) : '-' }}
                            </template>
                            <template #cell(wo_started_at)="data">
                              {{ data.item.wo_started_at ? momentDMHms(data.value) : '-' }}
                            </template>
                            <template #cell(wo_verified_at)="data">
                              {{ data.item.wo_verified_at ? momentDMHms(data.value) : '-' }}
                            </template>
                            <template #cell(wo_ended_at)="data">
                              {{ data.item.wo_ended_at ? momentDMHms(data.value) : '-' }}
                            </template>
                          </b-table>
                        </div>

                        <div class="row">
                          <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_length" class="dataTables_length">
                              <label class="d-inline-flex align-items-center">
                                <span>Menampilkan</span>
                                <span>
                                  <b-form-select
                                    class="form-select form-select-sm"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                    @change="resetFilter"
                                  />
                                </span>
                                <span>entri.&nbsp;&nbsp;</span>
                                <span>
                                  Menampilkan&nbsp;
                                  <strong>
                                    {{
                                      filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                                    }}
                                  </strong>
                                  &nbsp;sampai&nbsp;
                                  <strong>
                                    {{
                                      currentPage != totalPages
                                        ? currentPage * perPage
                                        : (currentPage - 1) * perPage + filteredItems.length
                                    }}
                                  </strong>
                                  &nbsp;dari&nbsp;
                                  <strong>{{ totalRows }}</strong>
                                  &nbsp;entri.
                                </span>
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                  v-if="!loading"
                                  v-model="currentPage"
                                  :total-rows="totalRows"
                                  :per-page="perPage"
                                  @change="changePage"
                                ></b-pagination>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Detail Time Log</span>
            </template>
            <DetailTimeLog />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
